module.exports = __webpack_public_path__ + "assets/img/sfyonghu.0de30480.png";